
export const USER_STATE_KEY = 'USER_STATE_KEY';
export const SALESMAN_REQUEST_TO_SYNC_KEY = 'SALESMAN_REQUEST_TO_SYNC_KEY';

export const saveToStorage = async (
  key: string,
  data: any,
  isObject: boolean = true,
) => {
  try {
    key ? null : null;
    isObject ? JSON.stringify(data) : data;
  } catch (e) {
    // saving error
  }
};

export const clearFromStorage = async (key: string) => {
  try {
    key ? null : null;
  } catch (e) {
    // error reading value
  }
};

export const loadFromStorage = async (
  key: string,
  isObject: boolean = true,
) => {
  try {
    const value = key ? null : null;
    if (value !== null) {
      return isObject ? JSON.parse(value) : value;
    } else {
      return null;
    }
  } catch (e) {
    // error reading value
  }
};
